module.exports = __webpack_public_path__ + "assets/img/Affiches_005.10352195.jpg";